<template>
	<iframe
		:id="blok._uid"
		class="mt-lg w-full"
		frameborder="0"
		scrolling="no"
		:height="height"
		width="1100"
		:src="blok.url"
		:title="blok.url"
		:allow="blok.attributes"
	></iframe>
</template>

<script lang="ts" setup>
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-iframe"}>;
}>();

const height = computed(() => properties.blok.height.value);
</script>
